angular.module('charts')
  .directive("cardGrid", function () {
      return {
          restrict: "E",
          scope: {
              items: '=',
              timeframe: '@',
              viewMode: '='
          },
          templateUrl: '/resources/charts/partials/card-grid.html',
          controller: ['$scope', '$element', '$rootScope', 'authentication', function ($scope, $element, $rootScope, dblAuthentication) {

              var updateMode = function() {
                  $scope.showPercents = dblAuthentication.growthAsFraction() ? false : true;
              };

              updateMode();

              var onEarlierYearSelectionChange = function (e) {
                  $scope.disableCardSelection = $rootScope.isEarlierYearSelected;
              };
              onEarlierYearSelectionChange();
              $rootScope.$on('earlierYearSelectionChange', onEarlierYearSelectionChange);

              $scope.handleCardClick = function (item) {
                  $scope.$emit('cardGridItemClicked', item);
              };

              $scope.onShowAverage = function (item) {
                  if (typeof item.average_active_students !== 'undefined') {
                      $scope.showAverage = true;
                  }
              };

              $scope.onHideAverage = function () {
                  $scope.showAverage = false;
              };

              $scope.getIndicatorStyle = function (statusProperty) {
                  switch (statusProperty) {
                      case 1:
                          return 'congratulate';
                      case 2:
                          return 'warn';
                      default:
                          return '';
                  }

              };

              $rootScope.$on('timeframeSelected', updateMode);
              $rootScope.$on('timeframeInitialized', updateMode);
          }]
      };
  });
